import { ProtocolSettings } from "./ProtocolSettings";
import { ProtocolSettingsTypes } from "./ProtocolSettingsTypes";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class PingSettings extends ProtocolSettings {

	public Timeout: number;
	public Retries: number;

	constructor() {
		super();

		this.Timeout = 2000;
		this.Retries = 1;
	}

	public get SettingsType(): string {
		return ProtocolSettingsTypes.Ping;
	}

	public get Summary(): string {
		return `Timeout: ${this.Timeout}; Retries: ${this.Retries}`;
	}

	public Copy(obj: ProtocolSettings): void {
		if (!(obj instanceof PingSettings))
			return;
		let other = (obj as PingSettings);

		super.Copy(obj);

		this.Timeout = other.Timeout;
		this.Retries = other.Retries;
	}

	public Clone(): ProtocolSettings {
		let clone = new PingSettings();
		clone.Copy(this);
		return clone;
	}

	public Equals(obj: any): boolean {
		if (!super.Equals(obj))
			return false;

		if (!(obj instanceof PingSettings))
			return false;
		let other: PingSettings = (obj as PingSettings);

		return (this.Timeout === other.Timeout &&
			this.Retries === other.Retries);
	}

	public Write(obj: any, context: any): void {
		obj.ping = {};
		obj = obj.ping;

		super.Write(obj, context);

		obj.timeout = ValueEncoder.EncodeInteger(this.Timeout);
		obj.retries = ValueEncoder.EncodeInteger(this.Retries);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ping)
			throw new Error();
		obj = obj.ping;

		super.Read(obj, context);

		if (obj.timeout !== undefined)
			this.Timeout = ValueEncoder.DecodeInteger(obj.timeout);

		if (obj.retries !== undefined)
			this.Retries = ValueEncoder.DecodeInteger(obj.retries);
	}

}

